import React, {Component} from 'react';
import {connect} from 'react-redux';
import store from 'store';
import pick from 'lodash.pick';

import {Button, Card, CardBody, CardHeader} from "reactstrap";
import {Field, reduxForm} from 'redux-form';

import {handleChangeDefaultMessages} from "./actions/settings";

import {InputField} from "../../validation/ReduxFormInput";

class DefaultMessages extends Component {
    render() {
        const {handleSubmit, _handleChangeDefaultMessages, pristine, submitting, invalid} = this.props;
        if (store.get('type') === 'landlord') return (
            <Card className="pr-card">
                <CardHeader tag="h4">Change Qualification & Deferral Messages</CardHeader>
                <CardBody>
                    <p>
                        <small>These are messages that are sent to tenants when you qualify or defer a group. You'll have the option to customize these for each group. When you qualify a group, you'll want to explain your next steps in the qualification message.</small>
                    </p>
                    <hr/>
                    <form onSubmit={handleSubmit(_handleChangeDefaultMessages)}>
                        <Field name="acceptance_message" label="Qualification Message" component={InputField} type="textarea"/>
                        <Field name="rejection_message" label="Deferral Message" component={InputField} type="textarea"/>
                        <Button color="success" type="submit" disabled={pristine || submitting || invalid}>Update Messages</Button>
                    </form>
                </CardBody>
            </Card>
        );
        else return null;
    }
}

const validate = (values) => {
    const errors = {};

    (values.acceptance_message && values.acceptance_message.length > 500) && (errors.acceptance_message = 'Keep this under 500 characters');
    (values.rejection_message && values.rejection_message.length > 500) && (errors.rejection_message = 'Keep this under 500 characters');

    return errors;
};

DefaultMessages = reduxForm({
    form: 'settings_messages',
    validate
})(DefaultMessages);

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
    _handleChangeDefaultMessages(data) {
        return dispatch(handleChangeDefaultMessages(data));
    }
});

//Get initial form values from state
DefaultMessages = connect(state => {
        let initial = Object.assign({}, pick(state.owner, [
                'acceptance_message',
                'rejection_message'
            ]
        ));

        return {
            initialValues: initial
        };
    }
)(DefaultMessages);

export default connect(mapStateToProps, mapDispatchToProps)(DefaultMessages);



// WEBPACK FOOTER //
// ./src/containers/settings/DefaultMessages.js